<script setup>
import { computed, onMounted, ref } from "vue";
// import getData from "../data";
import publications from "../data/articles.json";
import Article from "../components/CardArticleComponent.vue";
import Switcher from "../components/switcher/switcher.vue";
import gsap from "gsap";
import PagedComponent from "../components/paged/PagedComponent.vue";
import ColumnComponent from "../components/ColumnComponent.vue";
import PageTemplate from "./PageTemplate.vue";

const sorted_publications = computed(() => {
	return publications.sort((a, b) => new Date(a) - new Date(b));
});

const written = computed(() => {
	return publications.filter((p) =>
		p.author.toLowerCase().includes("lerone"),
	);
});
const _sections = ["writing", "news", "fringe arts", "sports", "opinions"];
const articles_by_section = computed(() => {
	let sections = new Set(publications.map((e) => e.section.toLowerCase()));
	let map = new Map();
	sections.forEach((section) =>
		map.set(
			section,
			publications
				.filter((pub) => !written.value.includes(pub))
				.filter((pub) => pub.section.toLowerCase() === section),
		),
	);
	map.set(
		"writing",
		publications.filter((pub) =>
			pub.author.toLowerCase().includes("lerone"),
		),
	);
	return map;
});
const sections = computed(() => {
	return new Set(publications.map((e) => e.section.toLowerCase()));
});

function set_tab(o) {
	page.value = 0;
	if (selected_section.value == o) {
		selected_section.value = null;
		return;
	}
	selected_section.value = o;
	// page.value = 0;
}

function next_page() {
	console.log(page_count.value);
	page.value = Math.min(page.value + 1, page_count.value);
}

function previous_page() {
	page.value = Math.max(page.value - 1, 0);
}

const selected_section = ref("");
const page = ref(0);

const current_section_articles = computed(() => {
	if (!articles_by_section.value.has(selected_section.value)) {
		return sorted_publications.value;
	}
	return articles_by_section.value.get(selected_section.value);
});
</script>

<template>
	<PageTemplate>
		<template #header>
			<h1>My Photos in The Link Newspaper</h1>
		</template>
		<div class="abel container-fluid publications thelink-photography">
			<!-- <h2>{{ selected_section}}</h2> -->
			<nav class="nav nav-pills flex-column flex-sm-row p-3">
				<a
					v-for="option in _sections"
					:atv="option"
					@click="set_tab(option)"
					class="flex-sm-fill text-sm-center nav-link"
					:class="({ active: selected_section === option }, option)"
					>{{ option }}</a
				>
			</nav>
			<ColumnComponent
				cols="3"
				:items="current_section_articles"
				class=""
				column-classes="d-flex flex-column gap-3"
			>
				<template #item="article">
					<RouterLink
						:to="`/publications/${article.section.toLowerCase()}/${article.slug}`"
					>
						<Article :article="article"></Article>
					</RouterLink>
				</template>
			</ColumnComponent>
		</div>
	</PageTemplate>
</template>
